import { useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'
import { DateUtilsRoomsSessions } from './date-utils-rooms-sessions'

export const createSession = async (data: any) => {
  const { getUnitId } = useLocalStorage()
  const { showToast } = useToast()
  const { httpClientPost } = useRemoteClientPost()
  const { getDatesByWeekDays, removeTimezone } = DateUtilsRoomsSessions()

  try {
    const initHour = data.inicioAula.getHours()
    const initMinutes = data.inicioAula.getMinutes()
    const finishHour = data.fimAula.getHours()
    const finishMinutes = data.fimAula.getMinutes()

    const datesSessions = getDatesByWeekDays(data.inicioAula, data.fimAula, data.diasDaSemana.map(Number))

    const sessions = datesSessions.map((dateSession) => ({
      ...data,
      inicioAula: removeTimezone(new Date(dateSession.setHours(initHour, initMinutes))),
      fimAula: removeTimezone(new Date(dateSession.setHours(finishHour, finishMinutes))),
      unidade: {
        id: getUnitId()
      }
    }))

    await httpClientPost('/aulas', sessions)
    showToast('Aula criada com sucesso', 'success')
  } catch (error) {
    CatchMessageError(error)
  }
}
